const popupSuggestionProps = () => ({
  isLoading: {
    type: Boolean,
    required: true
  },
  complementaires: {
    type: Array,
    required: true
  }
})

const popupSuggestionEmits = () => (["openSuggestionPopin"])

const usePopupSuggestion = (props) => {
  const getFirstTreeElements = computed(() => {
    return props.complementaires.slice(0, 3)
  })

  return {
    getFirstTreeElements
  }
}

export {
  popupSuggestionProps,
  popupSuggestionEmits,
  usePopupSuggestion
}